import React from "react";

import './Button.css';

export class Button extends React.Component {    
    render() {
        return (   
            <div className={this.props.class ? this.props.class + ' button-container' : ' button-container'} onClick={this.props.handler}>
                <div className={this.props.icon}>
                </div>
                <div className='button-title'>                    
                    {this.props.title}
                </div>
            </div>
        );
    }
}
